import FixaButton from "../../../shared/wrappers/FixaButton/FixaButton";
import CreateMultiAddOnOrdersButton from "./CreateMultiAddOnOrdersButton";

interface ActionBarContentProps {
  showAssignButton: boolean;
  assignButtonText: string;
  createButtonText: string;
  handleSubmit: () => void;
  isLoading: boolean;
  selectedArticlesCount: number;
  setShowAssignModal: (showAssignModal: boolean) => void;
  disabled: boolean;
  assignButtonDisabled: boolean;
}

const ActionBarContent = ({
  showAssignButton,
  assignButtonText,
  createButtonText,
  handleSubmit,
  isLoading,
  selectedArticlesCount,
  setShowAssignModal,
  disabled,
  assignButtonDisabled,
}: ActionBarContentProps) => (
  <>
    {showAssignButton ? (
      <FixaButton
        text={assignButtonText}
        type="primary"
        onClick={handleSubmit}
        disabled={assignButtonDisabled}
        loading={isLoading}
        data-testid="submitAssignMultiOrdersButton"
      />
    ) : (
      <CreateMultiAddOnOrdersButton
        selectedArticlesCount={selectedArticlesCount}
        onClick={() => setShowAssignModal(true)}
        disabled={disabled}
        createButtonText={createButtonText}
      />
    )}
  </>
);

export default ActionBarContent;
